// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__k6dyA","loading_green":"Spinner_loading_green__2wRmM","spin":"Spinner_spin__exvrK"};